@import "../../css/button.css";

:host {
  all: initial;
  color: var(--zapier-text);
  font-family: var(--zapier-font-family);
  display: block;
  position: relative;
  /* Iframes only have a transparent background when their color scheme matches
  the one of the parent page

  https://github.com/w3c/csswg-drafts/issues/4772

  https://fvsch.com/transparent-iframes
  */
  color-scheme: light dark;
}

.button {
  display: inline-block;
}

.tooltip {
  --tooltip-bg: #1f3121;
  --tooltip-fg: #fffdf9;
  --tooltip-tail-size: 12px;
  display: none;
  box-sizing: border-box;
  max-width: 29ch;
  padding: 16px;
  pointer-events: none;
  position: absolute;
  top: -80px;
  right: 180px;
  border-radius: 10px;
  background: var(--tooltip-bg);
  color: var(--tooltip-fg);
  /* This should really use filter:drop-shadow() instead to have the shadow
   * follow the shape of the ::after element, but it's currently hilariously broken
   * in Safari. Fortunately, this big comfy box-shadow extends well past the  arrow
   * tip and looks great.
   *
   * Sage Fennel (2022-10-11)
   */
  box-shadow: 0 10px 20px rgb(0 0 0 / 0.3);
}

.tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: calc(50% - var(--tooltip-tail-size));
  width: 0;
  height: 0;
  border: var(--tooltip-tail-size) solid transparent;
  border-top-color: var(--tooltip-bg);
}

:host(:hover) .tooltip:not([hidden]) {
  display: block;
}

.iframe {
  display: block;
  border: 0;
  box-sizing: border-box;
  width: 100%;
  height: 42px;
  /* Iframes only have a transparent background when their color scheme matches
  the one of the parent page

  https://github.com/w3c/csswg-drafts/issues/4772

  https://fvsch.com/transparent-iframes
  */
  color-scheme: light dark;
}

.iframe-warning {
  display: flex;
  align-items: center;
  gap: var(--zapier-grid-unit);
  font-weight: bold;
  padding: calc(2 * var(--zapier-grid-unit));
  border-radius: calc(var(--zapier-grid-unit) / 2);
  border: 1px solid var(--zapier-border-color);
  margin-bottom: var(--zapier-grid-unit);
}

.iframe-warning[hidden] {
  display: none;
}

.iframe-warning > svg {
  flex: 0 0 auto;
}
